module.exports = __webpack_public_path__ + "video/500_SERF_2022_HackerMotivations.8a1f0376.vtt";